// extracted by mini-css-extract-plugin
module.exports = {"stripeInput":"stripe_stripeInput__LHSA1"};